import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold" }, "Tools needed", -1)
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  id: "tools-modal",
  expand: "block",
  class: "opacity-70 underline"
}
const _hoisted_4 = ["src"]

import CardTemplate from "@/components/template/CardTemplate.vue"
  import BottomModal from "@/components/template/BottomModal.vue"

  interface Props {
    tools: [
      {
        name: string
      }
    ]
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ToolsNeeded',
  props: {
    tools: null
  },
  setup(__props: any) {

const props = __props as {
    tools: [
      {
        name: string
      }
    ]
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardTemplate, { class: "mx-3" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tools.slice(0, 5), (tool) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `${tool}_id`,
            class: "flex gap-3 items-center py-2"
          }, [
            _createElementVNode("img", {
              class: "h-6 w-6 object-contain",
              src: `https://assets.workbean.co/skill-logos/${tool.name}.png`,
              alt: "",
              onerror: "this.onerror=null;this.src='https://assets.workbean.co/error/techstack-error.png';"
            }, null, 8, _hoisted_2),
            _createElementVNode("span", null, _toDisplayString(tool.name), 1)
          ]))
        }), 128)),
        (__props.tools.length > 5)
          ? (_openBlock(), _createElementBlock("button", _hoisted_3, "See more"))
          : _createCommentVNode("", true)
      ]),
      _createVNode(BottomModal, { type: "tools-modal" }, {
        default: _withCtx(() => [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tools, (tool) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `${tool}_id`,
                class: "flex gap-3 items-center py-2"
              }, [
                _createElementVNode("img", {
                  class: "h-6 w-6 object-contain",
                  src: `https://assets.workbean.co/skill-logos/${tool.name}.png`,
                  alt: "",
                  onerror: "this.onerror=null;this.src='https://assets.workbean.co/error/techstack-error.png';"
                }, null, 8, _hoisted_4),
                _createElementVNode("span", null, _toDisplayString(tool.name), 1)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})